// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2Uiz_","modalForm":"UpgradeEpcsModal_modalForm__30YoR","modalFooter":"UpgradeEpcsModal_modalFooter__1QWAj"};